interface ServerErrorShape {
  details?: { message?: string | null } | null
}

export const readServerMessage = (data: unknown): string | undefined => {
  const message = (data as ServerErrorShape | null | undefined)?.details
    ?.message
  return typeof message === "string" && message.trim() ? message : undefined
}
